import React, { useEffect, useRef, useState } from 'react'
import './player-earnings-list.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
// import ImageContainer from '@/components/SHARED/image-container/image-container.component';
// import { format } from 'date-fns';
// import BackButton from '@/components/SHARED/back-button/back-button.component';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
// import PlayerNameIcon from '../player-name-icon.component';
import { getActivityRecordsQuery, getGameActivityFromDb } from '@/utils/getDataFromDb';
import TransactionView from '@/components/SHARED/transaction-view/transaction-view.component';
import DetailedActivityList from '@/components/SHARED/detailed-activity-list/detailed-activity-list.component';
import DetailedActivityListTable from '@/components/SHARED/detailed-activity-list/detailed-activity-list-table.component';
import { useSelector } from 'react-redux';

const PlayerEarningsList = ({
  gameData,
  playerData,
  gameElements,
  type,
  noPurchases,
  noNegative
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [loading, setLoading] = useState(true);
  const [activityToDisplay, setActivityToDisplay] = useState({});
  const [moreCount, setMoreCount] = useState(1);
  const [moreLimit, setMoreLimit] = useState(8);
  const [noMore, setNoMore] = useState(false);
  const activityRef = useRef({});
  const scrollRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000)

    return () => {
      if (timer) clearTimeout(timer);
    }
  }, [])

  useEffect(() => {

    if (
      location.pathname.includes(`/manage/${gameData.path}/players`) ||
      location.pathname.includes(`/preview/manager/${gameData.path}/players`)
    ) {
      //   console.log('scrolling')
      let scrollElement;
      if (screenSize === 'mobile') {
        scrollElement = document.querySelector('.detailed-activity-list-table');
      } else {
        scrollElement = document.querySelector('#scroll-to-top');
      }

      if (!scrollElement) return;

      if (scrollRef.current) {
        const timeout = setTimeout(() => {
          scrollElement.scrollTo({
            'behavior': 'smooth',
            'top': scrollRef.current + 40
          });
          clearTimeout(timeout);
        }, 100);
      } else {
        scrollElement.scrollTo({
          'behavior': 'smooth',
          'top': 0
        });
      }
    }

  }, [location])

  useEffect(() => {
    if (!playerData || !gameElements || !type) return;
    getActivityData();
  }, [playerData, gameElements, type])

  function getActivityData(next) {
    const queryFilter = [
      {
        'key': 'playerId',
        'value': playerData.playerId
      },
      {
        'key': 'elementId',
        'value': type
      },
      {
        'key': 'gameId',
        'value': playerData.gameId
      },
    ]
    // console.log(queryFilter)

    const queryObject = {
      'gameId': playerData.gameId,
      'path': 'activityRecords',
      'filter': queryFilter,
      'limit': moreLimit,
      'once': true,
      'callback': callback
    }
    if (next) {
      const len = Object.keys(activityRef.current).length;
      queryObject.lastEntry = Object.values(activityRef.current)
        .sort((a, b) => a.ts < b.ts ? 1 : -1)[len - 1];
    }
    getActivityRecordsQuery(queryObject)

    function callback(data) {
      // console.log(data);
      let filteredData = { ...data };
      if (noNegative) {
        filteredData = {};
        console.log(data);
        Object.values(data)
          .filter(a =>
            a.type !== 'purchase' &&
            a.spec !== 'negative' 
            &&
            (
              !playerData.newStuff || 
              playerData.newStuff.length === 0 ||
              !playerData.newStuff.map(n => n.id)
              .includes(a.id)
            )
          )
          .map(a => filteredData[a.id] = a);
        console.log(filteredData);
      }
      if (next) {
        activityRef.current = {
          ...activityRef.current,
          ...filteredData
        };
      } else {
        activityRef.current = { ...filteredData };
      }
      console.log(activityRef.current);
      if (Object.keys(data).length < moreLimit) {
        setNoMore(true);
      } else {
        setNoMore(false);
      }
      setActivityToDisplay(activityRef.current);
    }
  }
  // console.log('getXpEarningsList', playerData, lastTs);
  // getGameActivityFromDb({
  //     "gameId": playerData.gameId,
  //     "playerId": playerData.playerId,
  //     "elementId": 'xp',
  //     "limit": limit,
  //     "lastTs": lastTs,
  //     "once": true,
  //     "callback": callback,
  // })
  // function callback(data) {
  //     dataRef.current = {
  //         ...dataRef.current,
  //         ...data
  //     }
  //     console.log(data);
  //     setSortedList(Object.values(dataRef.current));
  //     setLoading(false);
  // }
  // }

  // function loadMore() {
  //     let tempData = {...dataRef.current};
  //     let lastTs = new Date().getTime();
  //     if (Object.values(tempData).length > 0) {
  //         const lastItem = Object.values(tempData).sort((a, b) => a.ts - b.ts)[0];
  //         console.log(lastItem);
  //         lastTs = lastItem.ts;
  //     }
  //     setLastTs(lastTs);
  //     setMoreCount(moreCount + 1);
  // }

  function goToTransaction(path) {
    if (screenSize === 'mobile') {
      scrollRef.current = document.querySelector('.detailed-activity-list-table').scrollTop;
    } else {
      scrollRef.current = document.querySelector('#scroll-to-top').scrollTop;
    }
    navigate(path);
  }

  function nextPage() {

    getActivityData(true);
    const timeout = setTimeout(() => {
      if (screenSize === 'mobile') {
        scrollRef.current = document.querySelector('.detailed-activity-list-table').scrollTop;
      } else {
        scrollRef.current = document.querySelector('#scroll-to-top').scrollTop;
      }
      clearTimeout(timeout);
    }, 200)
  }

  return (
    <div className='player-earnings-list'>

      <Routes>
        <Route path='' element={
          (loading)
            ?
            <div className='center-col'><ThreeDotsLoader /></div>
            :
            (
              Object.values(activityToDisplay).length > 0 &&
              playerData &&
              gameElements
            )
              ?
              <div>
                <div className='g-space-1'></div>
                <DetailedActivityListTable
                  gameData={gameData}
                  activityToDisplay={activityToDisplay}
                  hidePlayer={true}
                  playerData={playerData}
                  playerList={{ [playerData.playerId]: playerData }}
                  gameElements={gameElements}
                  gameManagers={[]}
                  goToTransaction={goToTransaction} />
                <div className="g-space-1"></div>
                {
                  (
                    !location.pathname.includes(`/preview/manager/`) &&
                    !location.pathname.includes(`/preview/player/`)
                  ) &&
                  <div className='center-col'>
                    <button
                      className={`g-button small-btn ${noMore ? 'disabled' : ''}`}
                      onClick={() => nextPage()}>
                      Load More...
                    </button>
                  </div>
                }
              </div>

              :
              <h4 className='center-col'>
                No earnings yet...
              </h4>
          // (sortedList)
          // ?
          // <div className='list-container'>
          // {
          // sortedList
          // .sort((a, b) => b.ts - a.ts)
          // .map((a, i) => {
          //     const data = Object.values(a.data).filter(d => d.type === 'xp')[0];
          //     return (
          //         <div key={a.ts} className='g-list-item xp-item'>
          //             <ImageContainer src={a.icon} className='icon' />
          //             <div className='info'>
          //                 <div className='title'>
          //                     <ImageContainer src='/images/xp.png' />
          //                     {data.title}
          //                 </div>
          //                 <div className='meta'>
          //                     {a.event}<br />
          //                     {format(new Date(a.ts), "Pp")}
          //                 </div>
          //             </div>
          //             {
          //                 (a.type === 'secretCode' && a.info)
          //                 ?
          //                 <div className='comment'>
          //                     Info:<br /><b>{a.info}</b>
          //                 </div>
          //                 :
          //                 (a.comments)
          //                 ?
          //                 <div className='comment'>
          //                     Comments:<br /><b>"{a.comments}"</b>
          //                 </div>
          //                 :
          //                 (a.info)
          //                 ?
          //                 <div className='comment'>
          //                     Info:<br /><b>{a.info}</b>
          //                 </div>
          //                 :
          //                 null
          //             }
          //         </div>
          //     )
          // })
          // }
          // {
          //     <div className='load-more center-col'>
          //         <button 
          //             className={`g-button med-btn ${
          //                 moreCount * limit > sortedList.length ? 'disabled' : ''
          //             }`} 
          //             onClick={loadMore}>
          //             Load More
          //         </button>
          //     </div>
          // }
          // </div>
        }></Route>
        <Route path=':transPath' element={
          <div className='transaction-container'>
            <div className='transaction-card'>
              {
                (playerData) &&
                <TransactionView
                  activityToDisplay={activityToDisplay}
                  playerList={{ [playerData.playerId]: playerData }}
                  gameElements={gameElements}
                  gameManagers={[]}
                  hidePlayer={true}
                  hideBackButton={true} />
              }
            </div>
          </div>
        }></Route>
      </Routes>
    </div>
  )
}

export default PlayerEarningsList;